import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { goToSlide } from "../../../thunks/editor/canvasThunks";
import { CanvasContext } from "../CanvasContext";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  addSlide,
  setCurrentSlideIndex,
  setSlides,
} from "../../../store/slides/slidesSlice";
import SlideDropdown from "./SlideDropdown";

import { ReactComponent as Information } from "../../../../src/assets/Information.svg";
import { useLocation } from "react-router-dom";
import { LAYOUTS } from "../../../constants/general";
import { setProjectLoading } from "../../../store/project/projectSlice";

const SlidesList = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const layout = queryParams.get("layout");
  const isPoitrate = layout === LAYOUTS.PORTRAIT;
  const [openSlideMenuIndex, setOpenSlideMenuIndex] = useState();
  const { slides, currentSlideIndex, loading } = useSelector(
    (state) => state.slides
  );
  const { isFaceless, isDoc, isLinkVideo } = useSelector(
    (state) => state?.project
  );

  const { loading: projectLoading, isNonVoice } = useSelector(
    (state) => state.project
  );

  const trial = useSelector((state) => state?.user?.details?.data?.trial);
  const { canvas } = useContext(CanvasContext);
  const [popover, setPopover] = useState(false);

  const slidesWithAvatarDId = slides.filter((slide) => {
    // Check if the slide has objects and any of them is an avatar with a URL including "d-id"
    return (
      slide.objects &&
      slide.objects.some((obj) => {
        return obj.type === "avatar" && obj.url.includes("d-id");
      })
    );
  });

  const shouldDisplayOneSlide = slidesWithAvatarDId.length >= 3;
  useEffect(() => {
    window.addEventListener("click", handleSlideMenu);

    return () => {
      window.removeEventListener("click", handleSlideMenu);
    };
  }, []);

  const handleSlideSelect = (index) => {
    console.log("loading", loading, projectLoading);
    // if (loading || projectLoading) {
    //   return;
    // }
    dispatch(setProjectLoading(true));
    console.log("index", index);
    console.log("currentSlideIndex", currentSlideIndex);
    if (currentSlideIndex !== index) {
      canvas.clear();
      canvas.renderAll();
      canvas.setBackgroundColor("white", canvas.renderAll.bind(canvas));
      dispatch(goToSlide(index, canvas));
    }
  };

  const handleSlideMenu = (index) => {
    return setOpenSlideMenuIndex((prev) =>
      index !== undefined ? (prev === index ? undefined : index) : undefined
    );
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const destinationIndex = result.destination.index;
    const sourceIndex = result.source.index;
    const tempSlides = [...slides];
    const [removed] = tempSlides.splice(sourceIndex, 1);
    tempSlides.splice(destinationIndex, 0, removed);

    const formatted = tempSlides.map((t, index) => ({
      ...t,
      label: index + 1,
    }));
    dispatch(setSlides(formatted));
    dispatch(setCurrentSlideIndex(destinationIndex));
    // Add code to reorder slides in your Redux state or local state here
  };
  const getMaxSlides = () => {
    if (trial) return 4;
    if (trial && isFaceless) return 4;
    if (shouldDisplayOneSlide) return 4;
    if (isNonVoice) return 20;
    return 10; // default max for non-trial, non-voice mode
  };

  const shouldShowAddButton = (
    slideLength,
    maxSlides,
    trial,
    shouldDisplayOneSlide
  ) => {
    if (slideLength < maxSlides) return true;
    return false;
  };
  const maxSlides = getMaxSlides(); // New function to dynamically calculate the maximum slides
  const showAddButton = shouldShowAddButton(
    slides.length,
    maxSlides,
    trial,
    shouldDisplayOneSlide
  ); // Manage the add button logic

  const renderPopover = (message) => (
    <div className="relative inline-block">
      <Information
        height={20}
        width={20}
        onClick={() => setPopover(!popover)}
        data-tip="tooltip"
      />
      {popover && (
        <div
          className="absolute bg-black text-white px-2 py-1 rounded-md text-sm z-10"
          style={{
            bottom: "30px",
            width: "250px",
            padding: "15px",
            transform: "translateX(-93%)",
          }}
        >
          {message}
        </div>
      )}
    </div>
  );

  // Workaround to make dnd work properly.

  return (
    <DragDropContext onDragEnd={handleOnDragEnd}>
      <Droppable droppableId="droppable" direction="horizontal">
        {(provided) => (
          <div
            className="flex items-center space-x-4 p-4"
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {slides.map((slide, index) => (
              <div key={"slide" + (index + 1)}>
                <div className="relative overflow-visible">
                  {openSlideMenuIndex === index && (
                    <SlideDropdown
                      handleSlideMenu={handleSlideMenu}
                      slideIndex={index}
                      className="left-[30%] bottom-[10px] w-[212px] min-h-[213px]"
                      disabled={shouldDisplayOneSlide || slides.length < 10}
                    />
                  )}
                </div>
                <Draggable
                  draggableId={"slide" + (index + 1)}
                  index={index}
                  draggable={"true"}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className={`relative rounded-lg shadow-lg bg-white overflow-hidden hover:shadow-xl hover:border border-gray-400 ${
                        currentSlideIndex === index
                          ? "cursor-default gradient-border-2 rounded-lg"
                          : "cursor-pointer"
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        return handleSlideSelect(index);
                      }}
                    >
                      <img
                        src={slide.thumbnail}
                        alt={slide.label || `Slide ${index + 1}`}
                        crossOrigin="anonymous"
                        className={`${
                          isPoitrate
                            ? "w-[95px] h-[110px]"
                            : "w-32 h-20 object-cover"
                        }   rounded-lg`}
                      />
                      <FontAwesomeIcon
                        icon={faEllipsisH}
                        className="cursor-pointer bg-slides-label rounded-sm w-6 h-4  absolute top-2 right-2 text-white"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          return handleSlideMenu(index);
                        }}
                      />
                      <div className="absolute top-2 left-2 text-white text-sm bg-slides-label w-6 text-center rounded-full">
                        {slide.label || `${index + 1}`}
                      </div>
                    </div>
                  )}
                </Draggable>
              </div>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      {showAddButton && (
        <AddThumbnailButton onAdd={() => dispatch(addSlide())} />
      )}
      {!showAddButton &&
        renderPopover(
          "In order to ensure stability, we will gradually increase the number of slides."
        )}
    </DragDropContext>
  );
};

const AddThumbnailButton = ({ onAdd }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const layout = queryParams.get("layout");
  const isPoitrate = layout === LAYOUTS.PORTRAIT;
  return (
    <button
      className={`${
        isPoitrate ? "w-[95px] h-[110px]" : "w-32 h-20"
      } bg-gray-200 flex items-center justify-center rounded-lg hover:shadow-xl hover:border border-gray-400`}
      onClick={onAdd}
    >
      <FontAwesomeIcon icon={faPlus} className="text-gray-400 text-2xl" />
    </button>
  );
};

export default SlidesList;
